import React, { useEffect, useRef, useState } from "react";

const AnimatedTitle = ({ text, className = "" }) => {
  const titleRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <h2 className={`animated-title ${className}`} ref={titleRef}>
      {text.split(" ").map((word, wordIndex) => (
        <span key={wordIndex} className="animated-word">
          {word.split("").map((letter, letterIndex) => (
            <span
              key={letterIndex}
              className={`animated-letter ${visible ? "show" : ""}`}
              style={{
                transitionDelay: `${wordIndex * 300 + letterIndex * 40}ms`,
              }}
            >
              {letter}
            </span>
          ))}
          {" "}
        </span>
      ))}
    </h2>
  );
};

export default AnimatedTitle;
